module.exports = __webpack_public_path__ + "static/zz_2_-501ee2245dcd077fc0afed36f551d382.png";